import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import SubscribeForm from '@/pages/about/components/SubscribeForm';
import { useSeo } from '@/hooks/useSeo';

const values = [
  {
    icon: 'ri-focus-3-line',
    title: '网站定位',
    desc: '黄色影视是一个面向影视爱好者的高清内容门户，聚合电影、电视剧与综艺节目，提供分类浏览、详情查看与影视资讯的一站式体验。',
  },
  {
    icon: 'ri-flag-line',
    title: '我们的使命',
    desc: '让找片变得更简单。我们用清晰的分类、可靠的筛选与及时的更新，帮助你更快找到想看的内容，把时间留给真正的观影时刻。',
  },
  {
    icon: 'ri-stack-line',
    title: '内容范围',
    desc: '覆盖动作、爱情、喜剧、悬疑、科幻、古装等多种题材，涵盖国产、欧美、日韩等地区，并按年份持续更新最新影视资源。',
  },
];

const stats = [
  { value: '24+', label: '影视作品' },
  { value: '15+', label: '细分题材' },
  { value: '每日', label: '内容更新' },
  { value: '3 类', label: '内容形式' },
];

export default function AboutPage() {
  useSeo({
    title: '关于我们 - 黄色影视',
    description:
      '了解黄色影视的网站定位、使命与内容范围。我们聚合高清电影、电视剧与综艺内容，提供便捷的分类浏览与影视资讯服务。',
    keywords: '关于黄色影视,影视平台介绍,黄色影视官网',
  });

  return (
    <SiteLayout>
      <section className="border-b border-background-200/70 bg-background-100/50">
        <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
          <nav className="flex items-center gap-1.5 text-sm text-foreground-500" aria-label="面包屑">
            <Link to="/" className="cursor-pointer transition-colors hover:text-primary-500">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <div className="mt-6 max-w-3xl">
            <span className="flex w-fit items-center gap-2 rounded-full bg-primary-500/15 px-4 py-1.5 text-xs font-medium text-primary-500">
              <i className="ri-information-line"></i>
              关于黄色影视
            </span>
            <h1 className="mt-5 font-heading text-3xl font-extrabold leading-tight text-foreground-950 md:text-4xl">
              一个更懂影视爱好者的内容门户
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              黄色影视专注于高清电影、电视剧与综艺内容聚合，用清晰的分类与便捷的检索，帮助你在海量影视资源中快速找到想看的内容。
            </p>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <section>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {values.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200/70 bg-background-100 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 rounded-lg border border-background-200/70 bg-background-100/50 p-6 md:p-10">
          <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="font-heading text-3xl font-extrabold text-primary-500 md:text-4xl">{stat.value}</p>
                <p className="mt-2 text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <SubscribeForm />
        </section>

        <section className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-8">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-contacts-line text-primary-500"></i>
              联系方式
            </h2>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/70 text-foreground-700">
                  <i className="ri-mail-line"></i>
                </span>
                <a href="mailto:hello@huangseyingshi.com" className="cursor-pointer text-foreground-700 transition-colors hover:text-primary-500">
                  hello@huangseyingshi.com（合作与投稿）
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/70 text-foreground-700">
                  <i className="ri-customer-service-2-line"></i>
                </span>
                <a href="mailto:support@huangseyingshi.com" className="cursor-pointer text-foreground-700 transition-colors hover:text-primary-500">
                  support@huangseyingshi.com（意见反馈）
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/70 text-foreground-700">
                  <i className="ri-time-line"></i>
                </span>
                <span className="text-foreground-700">在线服务时间：每日 09:00 - 22:00</span>
              </li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a href="https://weibo.com" target="_blank" rel="noreferrer" aria-label="微博" className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-background-200/70 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-weibo-fill text-lg"></i>
              </a>
              <a href="https://www.bilibili.com" target="_blank" rel="noreferrer" aria-label="哔哩哔哩" className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-background-200/70 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-bilibili-fill text-lg"></i>
              </a>
              <a href="https://www.douyin.com" target="_blank" rel="noreferrer" aria-label="抖音" className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-background-200/70 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div className="rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-8">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-shield-check-line text-primary-500"></i>
              免责声明与版权
            </h2>
            <div className="mt-5 space-y-4 text-sm leading-relaxed text-foreground-600">
              <p>
                <strong className="text-foreground-800">免责声明：</strong>
                本站为影视内容展示演示站点，站内所有影视资料、封面、简介、播放区域及资讯内容均为前端示例数据，
                <strong className="text-foreground-800">不提供任何真实影视资源的在线播放与下载</strong>。
              </p>
              <p>
                <strong className="text-foreground-800">版权声明：</strong>
                站内展示的影视信息与图片仅用于产品功能演示，相关版权归原作者及权利方所有。如涉及版权问题，
                请通过上方邮箱与我们联系，我们将及时处理。
              </p>
            </div>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}